
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlF as ObiOwnShipControlFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-f.js';
 
 
 

 
 export const ObiOwnShipControlF = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-f',
   elementClass: ObiOwnShipControlFElement,
   events: {
     
   }
  });
 
 